import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppErrorMsgComponent } from './app-error-msg.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AppErrorMsgComponent],
  exports: [ AppErrorMsgComponent ]
})
export class AppErrorMsgModule { }
